import { createSvgIcon } from '@mui/material';
import React from 'react';

export const KeyCreditIcon = createSvgIcon(
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.68742 17.5002V10.5002L-8.13007e-05 6.14599L3.79159 0.000162363H11.3749L15.1666 6.14599L12.4791 10.5002V17.5002L7.58325 15.8543L2.68742 17.5002ZM4.14575 15.4585L7.58325 14.3335L11.0208 15.4585V12.2918H4.14575V15.4585ZM4.60409 1.45849L1.70825 6.14599L4.60409 10.8335H10.5624L13.4583 6.14599L10.5624 1.45849H4.60409ZM6.70825 9.396L3.89575 6.60433L4.93742 5.56266L6.70825 7.3335L10.2291 3.79183L11.2708 4.81266L6.70825 9.396ZM4.14575 12.2918H11.0208H7.58325H4.14575Z"
            fill="currentColor"
        />
    </svg>,
    'KeyCredit'
);
